export default __webpack_public_path__ + "static/media/fibraOptica.16780639.jpg";